"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protocol = exports.CloudToDevice = exports.DeviceToCloud = exports.NAMESPACE = exports.Telemetry = exports.System = exports.State = exports.Message = exports.Event = exports.Device = exports.Consumable = exports.Alarm = void 0;
const effect_1 = require("effect");
const device_1 = require("../../device");
const Device = __importStar(require("./device"));
exports.Alarm = __importStar(require("./alarm"));
exports.Consumable = __importStar(require("./consumable"));
exports.Device = __importStar(require("./device"));
exports.Event = __importStar(require("./event"));
exports.Message = __importStar(require("./message"));
exports.State = __importStar(require("./state"));
exports.System = __importStar(require("./system"));
exports.Telemetry = __importStar(require("./telemetry"));
exports.NAMESPACE = 'Culligan.Protocol.V3';
exports.DeviceToCloud = effect_1.Schema.Union(Device.Blackbox.DeviceToCloud, Device.Gbfc.DeviceToCloud, Device.HydroTapBridge.DeviceToCloud, Device.Pelican2.DeviceToCloud, Device.SyncRo.DeviceToCloud).annotations({
    identifier: `${exports.NAMESPACE}.DeviceToCloud`,
    title: 'Device to Cloud',
    examples: [
        {
            deviceModel: 'fbfc',
            protocolVersion: 3,
            deviceVendor: 'qnc',
            messages: [
                {
                    channel: 'telemetry',
                    data: {
                        time: new Date('2019-03-05T14:48:07.63Z'),
                        d_open: device_1.Capability.Telemetry.DoorOpen.make({ value: true }),
                    },
                },
            ],
        },
    ],
});
exports.CloudToDevice = effect_1.Schema.Union(Device.Blackbox.CloudToDevice, Device.Gbfc.CloudToDevice, Device.HydroTapBridge.CloudToDevice, Device.Pelican2.CloudToDevice, Device.SyncRo.CloudToDevice).annotations({
    identifier: `${exports.NAMESPACE}.CloudToDevice`,
    title: 'Cloud to Device',
    examples: [
        {
            deviceModel: 'fbfc',
            protocolVersion: 3,
            deviceVendor: 'qnc',
            messages: [
                {
                    channel: 'command',
                    data: { command: 'reboot' },
                },
            ],
        },
    ],
});
exports.Protocol = effect_1.Schema.Union(exports.DeviceToCloud, exports.CloudToDevice).annotations({
    identifier: `${exports.NAMESPACE}.Protocol`,
    title: 'Message Protocol Version 3',
});
//# sourceMappingURL=index.js.map